import type { ExpertSummary } from "../../api";

/** Mermaid diagram preview. The design wants a rendered SVG + collapsible
 *  source view. Real mermaid rendering is deferred until the api ships
 *  per-artifact content — this placeholder shows the source frame and a
 *  stylized "diagram coming" tile.
 */
export function MermaidPreview({
  expert,
  source,
  filename,
}: {
  expert: ExpertSummary;
  source?: string;
  filename: string;
}) {
  const c = expert.color_token;
  const placeholder = source ?? sampleSource();
  return (
    <div style={{ maxWidth: 920, margin: "0 auto" }}>
      <div className="card" style={{ padding: 28, position: "relative" }}>
        <div
          style={{
            height: 240,
            borderRadius: 8,
            background: `repeating-linear-gradient(135deg, var(--${c}-tint) 0 14px, var(--card) 14px 28px)`,
            border: `1px dashed color-mix(in oklab, var(--${c}) 35%, var(--rule-2))`,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <span
            className="mono"
            style={{
              fontSize: 12,
              padding: "6px 12px",
              borderRadius: 4,
              background: "var(--card)",
              border: `1px solid color-mix(in oklab, var(--${c}) 35%, var(--rule))`,
              color: `var(--${c}-deep)`,
              fontWeight: 500,
            }}
          >
            mermaid render — coming with per-artifact endpoint
          </span>
        </div>
        <div
          style={{
            position: "absolute",
            bottom: 10,
            right: 14,
            fontFamily: "var(--mono)",
            fontSize: 10.5,
            color: "var(--ink-3)",
          }}
        >
          rendered from <code>{filename}</code>
        </div>
      </div>
      <pre
        style={{
          marginTop: 14,
          padding: 14,
          borderRadius: 8,
          background: "#0f0e0a",
          color: "#d3cdb8",
          fontFamily: "var(--mono)",
          fontSize: 12,
          overflow: "auto",
          maxHeight: 200,
        }}
      >
        {placeholder}
      </pre>
    </div>
  );
}

function sampleSource(): string {
  return `graph LR
  Client[Client SPA] --> API[API Gateway]
  API --> Job[Job Service]
  Job --> Queue[(Job Queue)]
  Queue --> Worker[Workers]
  Worker --> Out[(Output)]`;
}
